import React, { useContext, useState } from "react";
import { GlobalState } from "../Helper/Context";
import SurahReader from "../Helper/SurahReader";
import PlusIcon from "../Assets/Icon/PlusIcon";
import Close from "../Assets/Icon/Close";
import flatImage from "../Assets/Images/9.png";
const Reader = ({ mainReader, verseReader }) => {
  const { state, setState } = useContext(GlobalState);
  const [showReader, setShowReader] = useState(false);
  const handelShow = () => {
    setShowReader(!showReader);
  };
  const handelSelect = (reader) => {
    if (mainReader) {
      localStorage.setItem("selectedReader", JSON.stringify(reader));
      setState({
        ...state,
        selectedReader: reader,
      });
    } else {
      localStorage.setItem("selectedVerseReader", JSON.stringify(reader));
      setState({
        ...state,
        selectedVerseReader: reader,
      });
    }
  };
  const reader = mainReader || verseReader;
  return (
    <aside className="w-full flex-1 md:max-w-[300px] md:p-4">
      <div className="hidden items-center gap-2 md:flex">
        <img
          src={flatImage}
          alt="flatImage"
          className=" w-[55px] aspect-square rounded-2xl mb-4"
        />
        <h2 className=" text-[32px] text-[var(--MColor)]">
          {state.langTo === "EN" ? "القرآء" : "Readers"}
        </h2>
      </div>
      <ul
        className={`list-none mt-12 flex items-center flex-nowrap overflow-auto pl-10 gap-2 sm:mt-0 md:sticky md:top-0 md:rounded-[45px] md:py-4 md:px-2 md:flex-col md:items-start md:shadow ${
          state.langTo === "EN" && "notranslate"
        }`}
      >
        {reader.map((reader) => (
          <li
            key={reader.identifier}
            className="flex flex-col bg-[var(--LColor)] p-2 min-w-[120px] rounded-xl items-center gap-2 cursor-pointer relative shrink-0 md:flex-row md:bg-transparent"
            onClick={() => handelSelect(reader)}
          >
            <span
              className={` h-9 absolute top-1/2 -translate-y-1/2 [inset-inline-start:-9px] w-1 rounded-full bg-[var(--MColor)]  origin-center opacity-0 md:opacity-100  ${
                (mainReader &&
                  state.selectedReader.identifier === reader.identifier) ||
                state.selectedVerseReader.identifier === reader.identifier
                  ? "md:scale-1"
                  : "md:scale-0"
              }`}
            />

            <img
              src={reader.photo}
              alt={`صورة ${reader.name}`}
              className=" w-16 aspect-square rounded-[20px]"
            />
            <span
              className={` text-xs md:text-base  ${
                (mainReader &&
                  state.selectedReader.identifier === reader.identifier) ||
                state.selectedVerseReader.identifier === reader.identifier
                  ? "text-[var(--SColor)]"
                  : "text-[var(--TColor)]"
              }`}
            >
              {state.langTo === "EN" ? reader.name : reader.englishName}
            </span>
          </li>
        ))}
        {mainReader && (
          <li
            className="flex flex-col p-2 min-w-40 items-center gap-2 cursor-pointer relative shrink-0 md:flex-row"
            onClick={handelShow}
          >
            <div className="bg-[var(--MColor)] w-16 aspect-square grid place-items-center rounded-[20px]">
              <PlusIcon />
            </div>
            <span className="text-xs md:text-base">
              {state.langTo === "EN" ? "عــرض الــمــزيـــد" : "Show More"}
            </span>
          </li>
        )}
      </ul>
      {showReader && (
        <div
          className="backdrop fixed w-screen h-screen  bg-black z-10 top-0 left-0 opacity-30"
          onClick={handelShow}
        ></div>
      )}
      {mainReader && (
        <div
          className={`moreReader container fixed w-[90vw] h-[80vh] rounded-3xl left-1/2 -translate-x-1/2 z-20 bg-[#F5F7F9] overflow-auto transition-all ${
            showReader
              ? "bottom-[10vh] opacity-100"
              : "bottom-[-20vh] opacity-0 pointer-events-none"
          }`}
        >
          <div className="flex justify-between px-8 pt-4 items-center sticky top-0 bg-white">
            <span className=" text-2xl font-bold text-[var(--MColor)]">
              {state.langTo === "EN" ? "قائمة القراء" : "Reader List"}
            </span>
            <Close onclick={handelShow} />
          </div>
          <ul className="flex flex-wrap gap-4 px-8 py-4">
            {SurahReader.map((reader) => (
              <li
                key={reader.identifier}
                onClick={() => {
                  handelSelect(reader);
                  handelShow();
                }}
                className={`shadow p-1 rounded-lg text-sm md:p-4 c cursor-pointer md:rounded-2xl w-1/4 grow text-center text-[var(--MColor)] ${
                  state.selectedReader.identifier === reader.identifier &&
                  "text-white bg-[var(--MColor)]"
                }`}
              >
                {state.langTo === "EN" ? reader.name : reader.englishName}
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
};

export default Reader;
